import type {
  IVariable,
  ImageVariable,
  TextVariable,
} from '@carboncopyco/types';

export const isTextVariable = (variable: IVariable): variable is TextVariable =>
  variable.type === 'text';

export const isImageVariable = (
  variable: IVariable
): variable is ImageVariable => variable.type === 'image';
